import { render } from "./StockValueIllustrated.vue?vue&type=template&id=e1e3d3e2"
import script from "./StockValueIllustrated.vue?vue&type=script&lang=js"
export * from "./StockValueIllustrated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__